import { InitializeAcc, Profile, UserClassification } from '@Models/types';

export const isProfile = (profile: false | Profile): profile is Profile =>
  profile !== false;

export function getUserClassification(
  user: InitializeAcc | null
): UserClassification {
  if (!user || !user.profile) return 'none';

  const { jira_email, jira_api_key, testrail_api_key, testrail_username } =
    user.profile;

  const hasJira = !!jira_api_key && !!jira_email;
  const hasTestRail = !!testrail_api_key && !!testrail_username;

  if (!hasJira && !hasTestRail) return 'no-api';
  if (hasJira && !hasTestRail) return 'only-jira';
  if (!hasJira && hasTestRail) return 'only-testrail';

  return 'both';
}
